import { AbstractTaxService } from '@abstract-services/tax/1.0/tax.abstract-service';
import * as ngCommonHttp from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TaxAPI } from '@constants/api';
import {
  CatalogTaxRateResponse,
  StoreTaxOverrides,
  StoreTaxRateResponse,
  TaxRate,
} from '@interfaces/tax/1.0';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TaxService extends AbstractTaxService {
  putStoreUrl;
  putCatalogUrl;

  constructor(private http: ngCommonHttp.HttpClient) {
    super();
    this.putCatalogUrl = TaxAPI.PUT_CATALOG;
    this.putStoreUrl = TaxAPI.PUT_STORE;
  }

  getAllTaxOverrides(storeId: string): Observable<StoreTaxOverrides> {
    const url = this.putStoreUrl.replace(':storeId', storeId);

    return this.http.get(url).pipe(
      map((response: StoreTaxOverrides) => {
        return response;
      }),
    );
  }

  saveStoreDefaultTaxRate(storeId: string, taxRate: number): Observable<StoreTaxRateResponse> {
    const URL = this.putStoreUrl.replace(':storeId', storeId);
    const BODY: TaxRate = {
      taxRate,
    };
    return this.http.put(URL, BODY).pipe(
      map((response: StoreTaxRateResponse) => {
        return response;
      }),
    );
  }

  deleteStoreDefaultTaxRate(storeId: string): Observable<void> {
    const url = this.putStoreUrl.replace(':storeId', storeId);

    return this.http.delete(url).pipe(
      map(() => {
        return;
      }),
    );
  }

  saveCatalogTaxRate(
    storeId: string,
    catalogEntryId: string,
    taxRate: number,
  ): Observable<CatalogTaxRateResponse> {
    const URL = this.putCatalogUrl
      .replace(':storeId', storeId)
      .replace(':catalogEntryId', catalogEntryId);

    const BODY: TaxRate = {
      taxRate,
    };
    return this.http.put(URL, BODY).pipe(
      map((response: CatalogTaxRateResponse) => {
        return response;
      }),
    );
  }

  deleteCatalogTaxRate(storeId: string, catalogEntryId: string): Observable<void> {
    const URL = this.putCatalogUrl
      .replace(':storeId', storeId)
      .replace(':catalogEntryId', catalogEntryId);

    return this.http.delete(URL).pipe(
      map(() => {
        return;
      }),
    );
  }
}
